import { Box, makeStyles, Typography } from '@material-ui/core'
import numeral from 'numeral'
import { number, oneOfType, string } from 'prop-types'
import React from 'react'

const useStyles = makeStyles( {
  value: {
    fontSize: '0.9rem',
    lineHeight: '0.2rem',
    position: 'absolute',
    marginTop: '0.5rem',
  },
  label: {
    fontWeight: 'bold',
    fontSize: '1.125rem',
    lineHeight: '1rem',
  },
} )

const Value = ( { label, value, prefix, postfix } ) => {
  const classes = useStyles()

  return (
    <Box>
      <Typography className={classes.label} variant="overline">{label}</Typography>

      {value && (
      <Typography className={classes.value} variant="h3">
        {prefix}
        {Number.isNaN( parseFloat( value ) ) ? value : numeral( value ).format( '0.[0a]a' )}
        {postfix}
      </Typography>
      )}
    </Box>
  )
}

Value.propTypes = {
  label: string,
  value: oneOfType( [ number, string ] ),
  prefix: string,
  postfix: string,
}

Value.defaultProps = {
  prefix: null,
  postfix: null,
  label: null,
  value: null,
}

export default Value
